module.exports = __webpack_public_path__ + "static/media/hello-cycles.b18cec12.jpg";